import { mapState } from 'vuex'
import * as localStorageExpiry from '@/utils/local.storage.expiry'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  ...mapState({
    isQRCodeVisible: (state) => state.isQRCodeVisible,
    slideActive: (state) => state.slideActive,
  }),
  computed: {
    qrCodeKey() {
      return `closeAutoOpenQRCode-prez${this.presentation.id}`
    },
    hasClosedQRCode() {
      return localStorageExpiry.getWithExpiry(this.qrCodeKey)
    },
  },
  methods: {
    toggleQrCode(location) {
      this.$store.state.isQRCodeVisible = !this.$store.state.isQRCodeVisible
      if (!this.isQRCodeVisible && !this.hasClosedQRCode) {
        // Set local storage: closeAutoOpenQRCode-prez${this.prez.id} = true - exp in 2 months
        localStorageExpiry.setWithExpiry(this.qrCodeKey, true, 60 * 24 * 60 * 60 * 1000)
        if (location) this.trackGA(location)
      }
    },
    trackGA(location) {
      if (location === 'Instruction bar') {
        utils.mixpanelTracking(eventCategories.PRESENTING_MODE, 'QR code auto enable', 'Instruction bar to close QR code', this.slideActive.id, {
          slideIndex: this.slideActive.index,
        })
      } else if (location === 'Press Esc') {
        utils.mixpanelTracking(eventCategories.PRESENTING_MODE, 'QR code auto enable', 'Press Esc to close QR code', this.slideActive.id, {
          slideIndex: this.slideActive.index,
        })
      }
    },
  },
}
